export default __webpack_public_path__ + "static/record-evolution-screenshot-min-06297125dcded5d4a70e8cf06e8adee0.png";